/**
 * External dependencies
 */
import { get } from 'lodash';

export const getResourceId = state => get(state, 'ui.resourceInfoModal.resourceId', null);